const SHOW_MESSAGE = 'SHOW_MESSAGE';
const HIDE_MESSAGE = 'HIDE_MESSAGE';

const state = {
  snackbar: {
    key: '',
    active: false,
    top: true,
    color: 'success',
    text: '',
    timeout: 5000,
  },
};

const mutations = {
  [HIDE_MESSAGE](state) {
    state.snackbar = {
      key: '',
      active: false,
      top: true,
      color: 'success',
      text: '',
      timeout: 5000,
    };
  },
  [SHOW_MESSAGE](state, data) {
    Object.assign(state.snackbar, { ...data, active: true });
  },
};

const actions = {
  showMessage({ commit }, data) {
    commit(SHOW_MESSAGE, data);
    setTimeout(() => {
      commit(HIDE_MESSAGE, data);
    }, 5000);
  },
  hideMessage({ commit }) {
    commit(HIDE_MESSAGE);
  },
  errorMessage({ commit }, data) {
    commit(HIDE_MESSAGE, data);
  },
  showMessageValidateError({ dispatch }) {
    const data = { key: 'alert.formRequiredFieldsError', color: 'error' };
    dispatch('showMessage', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
